import { render, staticRenderFns } from "./ProposalActionButtons.vue?vue&type=template&id=63b6a66a"
import script from "./ProposalActionButtons.vue?vue&type=script&lang=js"
export * from "./ProposalActionButtons.vue?vue&type=script&lang=js"
import style0 from "./ProposalActionButtons.vue?vue&type=style&index=0&id=63b6a66a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports